import { randrange } from '@shared/src/utils/randrange';
import { TIME } from '@shared/src/utils/time';

import './spa-shishka.css';

const ATTR = 'spa-shishka';

export class SPAShishka extends HTMLDivElement {
  #img!: HTMLImageElement;

  constructor() {
    super();

    this.setAttribute('is', ATTR);
  }

  connectedCallback() {
    this.#img = this.querySelector('img')!;

    this.#img.onload = () => {
      this.dataset.loaded = 'true';

      this.#start();
    };

    this.#img.src = this.#img.dataset.src!;
  }

  #start = () => {
    this.#loop();
  };

  #loop = () => {
    setTimeout(
      () => {
        this.#show_up();

        this.#loop();
      },
      (() => {
        const delay = randrange(TIME.MINUTE, TIME.MINUTE * 5);

        console.log('NEXT SHISHKA in', delay, 'ms');

        return delay;
      })()
    );
  };

  #show_up = () => {
    this.className = '';

    this.classList.add(['top', 'right', 'bottom', 'left'][randrange(0, 3)]!);
    this.style.setProperty('--offset', `${randrange(10, 90)}%`);

    setTimeout(() => {
      this.classList.add('show-up');
    }, 100);
  };
}

customElements.define(ATTR, SPAShishka, { extends: 'div' });
